import { useRef, useState } from "react";
import { GameStates } from "../utils/constants";
import { QuestionTypes } from "../utils/types";

export function useInGameMessages() {
    const timeoutRef = useRef(null);
    const [inGameMessage, setInGameMessage] = useState(null);

    const changeInGameMessage = (game, hideAfter = 0) => {
        let message = "";
        switch (game?.state) {
            case GameStates.WELCOME:
                if(game.players.length <= 2) {
                    message = (
                        <div className="flex flex-col gap-1 items-center">
                            <p>En esta partida pondrás a prueba</p>
                            <p>TUS CONOCIMIENTOS</p>
                        </div>
                    );
                } else {
                    message = (
                        <div className="flex flex-col gap-1 items-center">
                            <p>¡Es momento de aprender jugando!</p>
                            <p>¡COMENCEMOS!</p>
                        </div>
                    );
                }
                break;
            case GameStates.SPINNER:
                if (game.applyJoker === false) {
                    if(game.players.length <= 2) {                        
                        message = game.shownQuestions.length === 1 ? "Preparando la primera pregunta..." : "Preparando la siguiente pregunta...";
                    } else {
                        switch (game.current_question.cardType) {
                            case QuestionTypes.CONOCIMIENTO:
                                message = "¡Hora de un Desafío de Conocimiento!";
                                break;
                            case QuestionTypes.CREATIVIDAD:
                                message = "¡Hora de un Desafío Creativo!";
                                break;
                            case QuestionTypes.TALENTO:
                                message = "¡Hora de un Desafío de Talento!";
                                break;
                            default:
                                message = "";
                                break;
                        }
                    }
                } else {
                    message = "¡Comodín! Un viajero al azar elegirá el siguiente desafío.";
                }
                break;
            default:
                message = "";
                break;
        }
        if (!message) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setInGameMessage(message);
        timeoutRef.current = setTimeout(() => {
            setInGameMessage(null);
            clearTimeout(timeoutRef.current);
        }, hideAfter);
    }

    const clearInGameMessage = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setInGameMessage(null);
    }

    return {
        inGameMessage,
        changeInGameMessage,
        clearInGameMessage
    };

}